module.exports = {"130629100":"容城镇","130629101":"小里镇","130629102":"南张镇","130629103":"大河镇","130629104":"晾马台镇","130629200":"八于乡","130629201":"贾光乡","130629203":"平王乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130629.json
// module id = 162
// module chunks = 0